import React from "react";
import { createPortal } from "react-dom";
import "./LoadingOverlay.scss";

function LoadingOverlay({ visible, message = "Processing your request..." }) {
  if (!visible) {
    return null;
  }

  const overlay = (
    <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="loading-overlay__card">
        <div className="loading-overlay__spinner" aria-hidden="true" />
        <p className="loading-overlay__message">{message}</p>
      </div>
    </div>
  );

  if (typeof document !== "undefined" && document.body) {
    return createPortal(overlay, document.body);
  }

  // Fallback for environments without a DOM (SSR)
  return overlay;
}

export default LoadingOverlay;
